import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { MergeAccountsDetails } from '@mfe/types/common';
import { html, TemplateResult } from 'lit';
import store from '@mfe/store';
import { TOGGLE_MERGE_ACCEPTED } from '@mfe/store/consents';

export const mergeAccountsWrapper = (mergeDetails: MergeAccountsDetails, innerHTML: TemplateResult, granted = false) => html`
  <div>
    <p data-testid="merge-account-wrapper">
      <strong>
        ${unsafeHTML(mergeDetails.headerText)}
      </strong>
    </p>
    <div class="form-row form-row--group">
        ${innerHTML}
    </div>
    <div class="form-group-checkbox form-group-checkbox--size-small">
      <input
        id="mergeCheckbox"
        name="mergeCheckbox"
        type="checkbox"
        .checked=${granted}
        @change=${() => store.dispatch({ type: TOGGLE_MERGE_ACCEPTED })}
      >
      <label for="mergeCheckbox">
        <strong>
            ${unsafeHTML(mergeDetails.checkboxText)}
        </strong>
      </label>
    </div>
  </div>`;

export default mergeAccountsWrapper;
